import emailApiConfig from "./emailApiConfig";

const EmailService = {
  async send(body) {
    return await emailApiConfig.post(
      `${process.env.REACT_APP_API_EMAIL}`,
      body
    );
  },
};

export default EmailService;
